// extracted by mini-css-extract-plugin
export default {"root":"ProjectHeader_root__RllG4","infoWrapper":"ProjectHeader_infoWrapper__PJpYy","loader":"ProjectHeader_loader__RzAIS"};